/** Контент лендинга `/use-cases/trade-show-timer` (вёрстка — `UseCasePageLayout`). */

import type { UseCasePageContent } from './useCasePageContent';

export const TRADE_SHOW_TIMER_CONTENT: UseCasePageContent = {
  heroEyebrow: 'ВЫСТАВКИ, ЭКСПО, СТЕНДЫ',
  heroLead:
    'Таймер для выставочной сцены и стендов. Соберите программу из нескольких докладчиков, держите регламент по секундам и выведите крупный отсчёт на экран стенда — без установки, в браузере.',
  heroNote: 'Бесплатно. Без регистрации, в браузере.',

  scenarios: {
    title: 'Где пригодится',
    lead:
      'preztimer держит тайминг там, где на ограниченном слоте сменяются докладчики и демонстрации, а отставание сразу видно команде.',
    items: [
      {
        title: 'Выставочная сцена',
        text: 'Череда коротких докладов: у каждого спикера свой слот, переход к следующему — по регламенту.',
      },
      {
        title: 'Демо на стенде',
        text: 'Таймер показа продукта и смены групп посетителей — крупный отсчёт виден на экране стенда.',
      },
      {
        title: 'Питч-сессии и конкурсы',
        text: 'Равное время участникам, отсчёт виден всем в экспо-зоне, перерасход — после нуля.',
      },
    ],
  },

  share: {
    title: 'Просто управлять, легко делиться',
    paragraphs: [
      'preztimer — таймер с удалённым управлением: запускайте, ставьте на паузу и сбрасывайте отсчёт с любого устройства в браузере. Координатор держит панель управления, докладчик видит экран таймера.',
      'Поделитесь экраном таймера по ссылке или QR-коду — без установки и регистрации. Сообщения на экране передают подсказки спикеру прямо во время выступления.',
    ],
  },

  cloud: {
    title: 'Программа выставочного дня',
    lead:
      'Соберите слоты заранее и держите весь день под рукой — без лишних экранов и установки.',
    bullets: [
      'таймер на каждый доклад или демо со своей длительностью;',
      'старт слота в заданное время по расписанию;',
      'переход к следующему таймеру — вручную с панели или с телефона.',
    ],
  },

  communication: {
    title: 'Сообщения докладчику и команде',
    lead:
      'Передавайте короткие подсказки на экран, не прерывая выступление на сцене или у стенда.',
    bullets: [
      'цветные сообщения: «время заканчивается», «переход к следующему»;',
      'общий доступ к таймеру по ссылке и QR-коду;',
      'синхронная работа на нескольких устройствах одновременно.',
    ],
  },

  modes: {
    title: 'Экран таймера на стенде',
    lead:
      'Выведите крупный читаемый отсчёт на ТВ или монитор стенда — видно со сцены и из зала.',
    bullets: [
      'полноэкранный режим, размер цифр подстраивается автоматически;',
      'цветовые зоны и показ перерасхода после нуля;',
      'обратный отсчёт, секундомер или часы (время суток).',
    ],
  },

  pricing: {
    title: 'Цены',
    lead:
      'Для одного стенда или сцены базовых функций хватит — бесплатно. Профи добавляет больше таймеров, комнат и подключений.',
  },

  crossLink: {
    title: 'Связанный сценарий: конференции',
    lead:
      'Программа в зале, несколько спикеров и сессий — отдельная страница с акцентом на конференционный формат.',
    to: '/use-cases/conferences',
    linkLabel: 'Таймер для конференций',
  },

  faqSectionTitle: 'Частые вопросы о таймере для выставки',
  faqItems: [
    {
      question: 'Можно ли подготовить таймеры выставочного дня заранее?',
      answer:
        'Да. Создайте таймеры на доклады и демо, а нужным слотам задайте старт в конкретное время и дату. К следующему таймеру вы переходите вручную с панели управления, в том числе с телефона.',
    },
    {
      question: 'Как вывести таймер на экран стенда?',
      answer:
        'Откройте экран таймера по ссылке и выведите его на ТВ или монитор стенда — по кабелю HDMI или беспроводным дублированием с ноутбука, планшета или телефона. Крупный отсчёт читается из зала.',
    },
    {
      question: 'Можно ли пользоваться бесплатно?',
      answer:
        'Да. Базовых функций тайминга достаточно для одной сцены или стенда — это бесплатно, до 3 одновременных подключений. Для команды и больших лимитов есть лицензия Профи.',
    },
    {
      question: 'Несколько человек могут управлять таймером?',
      answer:
        'Да. Панель управления можно открыть на нескольких устройствах, а экран таймера для докладчика держать отдельной ссылкой без доступа к управлению. На лицензии Профи можно подключить участников команды.',
    },
    {
      question: 'Могут ли посетители отправлять вопросы спикеру?',
      answer:
        'Нет, сбора вопросов от зрителей сейчас нет. Для подсказок спикеру используйте короткие сообщения на экране таймера и цветовые зоны.',
    },
    {
      question: 'Чем комната отличается от подключений?',
      answer:
        'Комната — это набор таймеров вашей выставки. Подключения — число устройств, одновременно открытых в комнате. На Базовом доступно 3 подключения, на Профи — 5 с возможностью расширения.',
    },
  ],
};
